import {createSlice} from '@reduxjs/toolkit'
import { getNotificationItem } from '@/store/notifications/action';

const initialState = {
  state: {
    items: [],
    paging: {}
  },
  loading: true,
  error: ''
} as BaseState<NotificationState>

const slice = createSlice({
  name: 'notificationSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNotificationItem.pending, (state) => ({
        ...state,
        loading: true
      }
    ))
    builder.addCase(getNotificationItem.fulfilled, (state, action) => {
      const { items, paging } = action.payload
      return {
        state: {
          items,
          paging
        },
        loading: false,
        error: null
      }
    })
    builder.addCase(getNotificationItem.rejected, (state) => ({
        ...state,
        loading: true,
        error: 'Failed fetching notifications'
      }
    ))
  }
})

export const authActions = slice.actions

export default slice
